(function () {
  function $(sel) { return document.querySelector(sel); }

  function getHeaderParts() {
    // Lo más común en Shopify:
    var headerSection = $('#shopify-section-header') || $('.shopify-section-header') || $('header');
    var announceSection = $('#shopify-section-announcement-bar') || $('.shopify-section-announcement-bar');

    return { headerSection: headerSection, announceSection: announceSection };
  }

  function getHeight(el) {
    if (!el) return 0;
    var rect = el.getBoundingClientRect();
    return Math.round(rect.height || 0);
  }

  function ensureSpacer() {
    var spacer = document.getElementById('LuumHeaderSpacer');
    if (spacer) return spacer;

    spacer = document.createElement('div');
    spacer.id = 'LuumHeaderSpacer';
    spacer.setAttribute('aria-hidden', 'true');

    // Insertamos ANTES del main si existe, si no, al inicio del body
    var main = document.querySelector('main');
    if (main && main.parentNode) {
      main.parentNode.insertBefore(spacer, main);
    } else {
      document.body.insertBefore(spacer, document.body.firstChild);
    }
    return spacer;
  }

  function updateSpacer() {
    var parts = getHeaderParts();
    var spacer = ensureSpacer();

    // Sumamos header + announcement (si existen)
    var total = getHeight(parts.announceSection) + getHeight(parts.headerSection);

    // Evita 0 por frames raros
    if (total < 10) return;

    spacer.style.height = total + 'px';
  }

  function init() {
    updateSpacer();

    window.addEventListener('resize', function () {
      updateSpacer();
    });

    // En iOS el header puede cambiar altura al hacer scroll
    window.addEventListener('scroll', function () {
      // muy liviano (sin lecturas masivas)
      updateSpacer();
    }, { passive: true });

    // Si el tema cambia clases/estructura del header
    try {
      var parts = getHeaderParts();
      var target = parts.headerSection || document.body;
      var mo = new MutationObserver(function () { updateSpacer(); });
      mo.observe(target, { attributes: true, childList: true, subtree: true });
      if (parts.announceSection) {
        mo.observe(parts.announceSection, { attributes: true, childList: true, subtree: true });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();